import moment from 'moment-timezone'

export const getGridTimeslots = (availableTimes, service) => {
  let timeslots = []

  if(availableTimes && availableTimes.length > 0) {
    let currentTime = moment(availableTimes[0].time)
    const lastTime = moment(availableTimes[availableTimes.length - 1].time)

    const timeIncrement = Math.max(service.timeIncrement, 5)

    while(currentTime.isSameOrBefore(lastTime)) {
      // eslint-disable-next-line
      const timeslot = availableTimes.find(at => at.time >= currentTime.toISOString())

      // Add empty slots for breaks / busy times
      const emptySlots = Math.floor(moment.duration(moment(timeslot.time).diff(currentTime)).asMinutes() / timeIncrement)
      if (emptySlots > 0) {
        timeslots = [...timeslots, ...new Array(emptySlots)]
      }

      if (timeslot) {
        timeslots.push(timeslot)
      }

      currentTime = moment(timeslot.time).add(timeIncrement, 'minutes')
    }
  }

  return timeslots
}


export const replaceEmptyGridRows = (timeslots, columns) => {
  let newTimeslots = []
  const rows = Math.ceil(timeslots.length / columns)

  for(let row = 0; row < rows; row++){
    let rowCells = timeslots.slice(row * columns, (row * columns) + columns)
    if(rowCells.every(c => !c)) {
      const lastCell = newTimeslots[newTimeslots.length - 1]
      if( !lastCell || !lastCell.separator ) newTimeslots.push({ separator: true })
    } else {
      newTimeslots = [...newTimeslots, ...rowCells]
    }
  }

  return newTimeslots
}

export const addDayLabels = (timeslots, timezone, dateFormat) => {
  let newTimeslots = [], currentDayOfYear = null

  for(const timeslot of timeslots) {
    if(timeslot && timeslot.time) {
      const dayOfYear = moment.tz(timeslot.time, timezone).dayOfYear()
      if(dayOfYear !== currentDayOfYear) {
        newTimeslots.push({ dayLabel: moment.tz(timeslot.time, timezone).format(dateFormat) })
        currentDayOfYear = dayOfYear
      }
    }
    newTimeslots.push(timeslot)
  }

  return newTimeslots
}
